// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".YIybS{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;grid-gap:8px;gap:8px;grid-gap:.5rem;gap:.5rem;background-color:#fff;border-radius:.5rem;padding:1.5rem;margin:2rem 0}._2I1W6{max-width:120px;max-width:7.5rem}._2FwN0{display:none}._3VIQY{margin-top:1rem}._3jXtX{font-size:14px;font-weight:300;line-height:23px;font-family:var(--base-font)}@media(max-width:767px){._3jXtX{font-size:16px;line-height:26px}}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"root": "YIybS",
	"lineProgressBar": "_2I1W6",
	"completedProgressBody": "_2FwN0",
	"button": "_3VIQY",
	"preOrderedDescription": "_3jXtX"
};
module.exports = exports;
